import { apiClient } from "../apiClient";
import { INhomLop } from "../../model/respone/classes/INhomLop";
import { IChotDuLieuResult } from "../../model/respone/registration/IChotDuLieuResult";
import { IMyRegistration } from "../../model/respone/registration/IMyRegistration";
import { IRegistrationResult } from "../../model/respone/registration/IRegistrationResult";
import { getQueueToken } from "../../helpers/queueToken";

const queueHeaders = (): Record<string, string> => {
    const token = getQueueToken();
    return token ? { "X-Queue-Token": token } : {};
};

export const registrationApi = {
    Register: (classId: number) =>
        apiClient.post<IRegistrationResult>(
            "registration",
            { classId },
            { headers: queueHeaders() }
        ),
    /** Phase 2C: đăng ký atomic 2 lớp (parent LT + child LTH/SH). */
    RegisterPair: (parentClassId: number, childClassId: number) =>
        apiClient.post<IRegistrationResult>(
            "registration/pair",
            { parentClassId, childClassId },
            { headers: queueHeaders() }
        ),
    Cancel: (classId: number) =>
        apiClient.delete<IRegistrationResult>(
            `registration/${classId}`,
            { headers: queueHeaders() }
        ),
    GetMy: () => apiClient.get<IMyRegistration[]>("registration/my"),
    /** SV bấm "Lưu dữ liệu đăng ký" — khoá đăng ký, không truyền body. */
    ChotDuLieu: () =>
        apiClient.post<IChotDuLieuResult>(
            "registration/chot-du-lieu",
            {},
            { headers: queueHeaders() }
        ),
    /** Catalog nhóm lớp đợt hiện tại — render combobox filter. */
    GetNhomLops: () => apiClient.get<INhomLop[]>("registration/nhom-lops"),
    /** Bulk fetch slot count nhẹ — refresh Bảng 3 khi chọn môn / click Tải lại. */
    GetSlots: (classIds: number[]) =>
        apiClient.get<Record<number, number>>(`registration/slots?ids=${classIds.join(",")}`),
};
